module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/homeofthebrave.616f0b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/homeofthebrave.jpg
// module id = bEcP
// module chunks = 0